<div class="idp-form-grouped">
  <input
    autocomplete="off"
    class="idp-input idp-input--error"
    name="input Error"
    type="text"
  />
  <label class="idp-label idp-label--error">Demo Error Label</label>
</div>
